import { useFormContext } from 'react-hook-form';
import { WithAccountId } from '@mews-commander/types';
import { ListHeadline, Stack, Typography } from '@optimus-web/core';
import { FormInputField, FormSelectField, lt } from '@mews/framework';
import { isDefined } from '@mews/std';
import { SuspenseBoundary } from '@mews-commander/ui';
import { CreatePaymentPlanFormValues } from '../schema';
import { useGetReservationsForCreatePaymentPlanSuspense } from '../hooks';
import { CreatePaymentPlanFormField } from '../types';
import { getReservationById } from '../../../tables/PaymentPlans/utils';
import { renderReservationItem } from '../../../ReservationAsyncSelect/renderReservationItem';
import { CreatePaymentPlanBillingModeField } from './CreatePaymentPlanBillingModeField';
import { PlanDetailsReservationFields } from './PlanDetailsReservationFields';

export const PlanDetailsFormFields = ({ accountId }: WithAccountId) => {
    const { watch, trigger } = useFormContext<CreatePaymentPlanFormValues>();
    const reservations = useGetReservationsForCreatePaymentPlanSuspense({ accountId });

    const selectedReservationId = watch(CreatePaymentPlanFormField.ReservationId);
    const selectedReservation = getReservationById(reservations, selectedReservationId);

    return (
        <Stack vertical spacing="300">
            <FormInputField
                name={CreatePaymentPlanFormField.PlanName}
                label={lt('CreatePaymentPlanFormPlanNameLabel')}
                required
            />
            <FormSelectField
                name={CreatePaymentPlanFormField.ReservationId}
                label={lt('CreatePaymentPlanFormReservationLabel')}
                required
                helper={lt('CreatePaymentPlanFormReservationHelper')}
                onChange={() => void trigger(CreatePaymentPlanFormField.ReservationId)}
            >
                {reservations.length > 0 && (
                    <ListHeadline>
                        <Typography textStyle="bodyMedium" variant="tertiary" as="div">
                            {lt('CreatePaymentPlanFormReservationListHeadline')}
                        </Typography>
                    </ListHeadline>
                )}
                {reservations.map((r) => renderReservationItem(r))}
            </FormSelectField>
            {isDefined(selectedReservation) && selectedReservation.isValid ? (
                <SuspenseBoundary loader="inline">
                    <PlanDetailsReservationFields accountId={accountId} reservation={selectedReservation} />
                </SuspenseBoundary>
            ) : (
                <CreatePaymentPlanBillingModeField />
            )}
        </Stack>
    );
};
